// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UploadButton {
  border: none;
  padding: 0;
  margin: 0;
  background: none;
  cursor: pointer;
  outline: none;
}
.UploadButton:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/modules/documents/upload-button/upload-button.styles.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;AACF;AACE;EACE,YAAA;EACA,mBAAA;AACJ","sourcesContent":[".UploadButton {\n  border: none;\n  padding: 0;\n  margin: 0;\n  background: none;\n  cursor: pointer;\n  outline: none;\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
